<template>
  <b-container class="tshirt-maker-banner-container mt-4" fluid>
    <b-container class="my-5">
      <b-row>
        <b-col cols="12" md="6" class="image-container order-6 order-md-0">
          <picture>
            <source
              srcset="https://cdn.vexels.com/img/merch-tshirt-maker.png?fmt=webp&w=300"
              type="image/webp"
              media="(max-width: 992px)"
            />

            <source
              srcset="https://cdn.vexels.com/img/merch-tshirt-maker.png?fmt=webp"
              type="image/webp"
            />

            <source srcset="https://cdn.vexels.com/img/merch-tshirt-maker.png" type="image/png" />

            <img
              class="img-fluid"
              src="https://cdn.vexels.com/img/merch-tshirt-maker.png"
              :alt="$t('home.merch.sector5.altImage')"
              height="400"
              width="400"
              loading="lazy"
            />
          </picture>
        </b-col>
        <b-col cols="12" md="6" class="flex py-4 d-flex align-items-center position-relative">
          <b-row class="text-center">
            <b-col col>
              <h2 class="title pb-4">{{ $t('home.merch.sector5.title') }}</h2>
              <p class="description">
                {{ $t('home.merch.sector5.description') }}
              </p>
              <div class="button">
                <Button
                  shape="full"
                  color="white"
                  text="exp"
                  :blank="true"
                  to="https://www.vexels.com/t-shirt-maker"
                >
                  {{ $t('home.merch.sector5.button') }}
                </Button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  }
};
</script>

<style lang="scss" scoped>
.tshirt-maker-banner-container {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('https://cdn.vexels.com/img/TShirtMaker.jpg');
  background-size: cover;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.title {
  text-align: left;
  font-weight: 500;
  color: white;
  font-size: 2.5em;
  margin-bottom: 5px;
}
.subtitle {
  text-align: left;
  font-weight: 400;
  color: white;
  font-size: 16px;
  margin-bottom: 5px;
}
.description {
  text-align: left;
  font-weight: 400;
  color: white;
  font-size: 0.8em;
  margin-bottom: 50px;
}
.button {
  text-align: left;
}
</style>
